import { gql } from "@apollo/client";

export interface LookupCompanyFilter {
  sortDirection?: "ASC" | "DESC";
  sortBy?: "NAME" | "ORGANIZATION_NUMBER" | "RELEVANCE";
  searchTerm: string;
  skip?: number;
  take?: number;
  isIssuer?: boolean;
  isRecipient?: boolean;
}

export type ClientType =
  | "ISSUER"
  | "ISSUER_AND_RECIPIENT"
  | "NONE"
  | "RECIPIENT"
  | "UNKNOWN";

export type LookupCompany = {
  clientIdentifier: string;
  clientType: ClientType;
  companyName: string;
  id: string;
};

export interface LookupCompanyResult {
  lookup: {
    quickcompany: {
      totalCount: number;
      pageInfo: {
        hasNextPage: boolean;
        hasPreviousPage: boolean;
      };
      items: Array<LookupCompany>;
    };
  };
}

const GET_LOOKUP_COMPANY = gql`
  query lookup(
    $sortDirection: SortDirection
    $sortBy: QuickCompanyLookupSortBy
    $searchTerm: String!
    $isIssuer: Boolean
    $isRecipient: Boolean
    $skip: Int
    $take: Int
  ) {
    lookup {
      quickcompany(
        sortDirection: $sortDirection
        sortBy: $sortBy
        searchTerm: $searchTerm
        isIssuer: $isIssuer
        isRecipient: $isRecipient
        skip: $skip
        take: $take
      ) {
        totalCount
        pageInfo {
          hasNextPage
          hasPreviousPage
        }
        items {
          id
          clientIdentifier
          clientType
          companyName
        }
      }
    }
  }
`;

export default GET_LOOKUP_COMPANY;
